import { motion, AnimatePresence } from "framer-motion";
import { X, Instagram, Phone, Mail, MessageCircle } from "lucide-react";

const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.5 3c.3 2.1 1.5 3.6 3.5 3.9v2.4c-1.3.1-2.5-.3-3.5-.9v6.1c0 3.1-2.5 5.5-5.6 5.5S5.3 17.6 5.3 14.5c0-2.9 2.3-5.3 5.2-5.5v2.5c-1.5.2-2.7 1.5-2.7 3 0 1.7 1.3 3 3 3s3-1.3 3-3V3h2.7z" />
  </svg>
);

const LINKS = [
  { key: "instagram", label: "Instagram", value: "@exotic_reefing_inc", href: "https://instagram.com/exotic_reefing_inc", Icon: Instagram },
  { key: "tiktok", label: "TikTok", value: "@exotic.reefing", href: "https://www.tiktok.com/@exotic.reefing", Icon: TikTokIcon },
  { key: "whatsapp", label: "WhatsApp", value: "(954) 868-0608", href: "https://wa.me/19548680608", Icon: MessageCircle },
  { key: "call", label: "Call us", value: "(954) 868-0608", href: "tel:+19548680608", Icon: Phone },
  { key: "email1", label: "Email", value: "ariana.exoticreefing@icloud.com", href: "mailto:ariana.exoticreefing@icloud.com", Icon: Mail },
  { key: "email2", label: "Email", value: "exoticreefinginc@icloud.com", href: "mailto:exoticreefinginc@icloud.com", Icon: Mail },
];

export function ContactModal({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[130] bg-void/90 backdrop-blur-md flex items-center justify-center p-4"
          data-testid="contact-modal"
        >
          <motion.div
            initial={{ scale: 0.94, y: 20, opacity: 0 }} animate={{ scale: 1, y: 0, opacity: 1 }} exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md glass rounded-2xl border border-cyan/25 p-7"
          >
            <button onClick={onClose} data-testid="contact-modal-close"
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/20 transition-colors">
              <X size={18} />
            </button>
            <span className="mono-label text-cyan">Get in touch</span>
            <h2 className="font-display text-3xl mt-2 mb-6">Contact us</h2>
            <div className="flex flex-col gap-2.5">
              {LINKS.map(({ key, label, value, href, Icon }) => (
                <a
                  key={key}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
                  data-testid={`contact-${key}`}
                  className="group flex items-center gap-4 rounded-xl border border-white/10 hover:border-cyan/50 bg-white/[0.02] hover:bg-cyan/5 px-4 py-3 transition-all"
                >
                  <span className="w-10 h-10 rounded-full bg-cyan/10 border border-cyan/25 flex items-center justify-center text-cyan shrink-0 group-hover:scale-110 transition-transform">
                    <Icon size={19} />
                  </span>
                  <span className="min-w-0">
                    <span className="block mono-label text-white/40 text-[0.6rem]">{label}</span>
                    <span className="block text-white/90 text-sm truncate">{value}</span>
                  </span>
                </a>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
